define.alias("shared/components/shared/post/profile-selector", "settings/components/shared/post/profile-selector/index");